module.exports = __webpack_public_path__ + "img/about2.73757108.png";